




















import VueStrong from '@/vueStrong';
import Pin from './Pin.vue';
import IPin from '@/shared/interfaces/Pin';
import { Component, Prop, Vue } from 'vue-property-decorator';
import StrongVueClass from '@/vueStrong';

@Component({
  components: {
    Pin,
  },
})
export default class PinColumn extends StrongVueClass {
    @Prop() private pins!: IPin[];
    @Prop() private col_id!: number;

    @Prop() private pin_width!: number;
    @Prop() private pin_height!: number;

    @Prop() private param_left!: number;
    @Prop() private param_top!: number;

    @Prop() private rotation!: number;

    constructor() {
        super();
    }
}
